<template>
	<div class="banner-promo-tip--container">
		<div
			class="inner-container"
			:class="content.alignment"
		>
			<div
				class="content-container"
				:class="[content.fullwidth && 'fullwidth', content.outlined && 'outlined', content.background]"
			>
				<div class="heading">
					<TnHeading
						type="h3"
						size="s"
						v-if="content.heading"
						v-editable-string
					>
						{{ content.heading }}
					</TnHeading>
				</div>
				<div class="body">
					<TnParagraph
						color="black"
						size="s"
						v-if="content.text"
						v-editable-string
						class="banner-content"
					>
						{{ content.text }}
					</TnParagraph>

					<div class="banner-cta-text">
						<div
							v-if="!content.ctaText && anchorLink"
							class="banner-cta-link"
						>
							<TnParagraph
								color="black"
								size="s"
								bold
								v-editable-string
							>
								{{ anchorLink.text }}
							</TnParagraph>
							<TnIcon
								name="right"
								color="#0C1026"
								size="m"
								class="banner-icon animated bounce"
							/>
						</div>

						<div
							v-if="content.ctaText && !anchorLink"
							class="banner-cta-link"
						>
							<TnParagraph
								color="black"
								size="s"
								bold
								v-editable-string
							>
								{{ content.ctaText }}
							</TnParagraph>
							<TnIcon
								name="right"
								color="#0C1026"
								size="m"
								class="banner-icon animated bounce"
							/>
						</div>

						<div
							v-else
							class="banner-cta-link"
						></div>
					</div>
				</div>
				<div class="divider"></div>
			</div>
		</div>
	</div>
</template>

<script>
import AnchorViewModel from "../../../../../helpers/ViewModels/AnchorViewModel.js";

export default defineNuxtComponent({
	name: "BannerPromoTipContent",

	computed: {
		anchorLink() {
			return this.content.anchorLink && this.content.anchorLink.anchorText && AnchorViewModel(this.content.anchorLink);
		},
	},

	props: {
		content: {
			type: Object,
			required: true,
		},
	},

	methods: {
		scroll() {
			const item = document.querySelector(`[id='${this.anchorLink.href}']`);
			if (item) {
				item.scrollIntoView({ behavior: "smooth", block: "center" });
				this.$store.dispatch("setAutoScrolling", true);

				setTimeout(() => {
					this.$store.dispatch("setAutoScrolling", false);
				}, 1000);
			}
		},
	},
});
</script>

<style lang="scss" scoped>
.banner-promo-tip--container {
	display: grid;
	width: 100%;

	.inner-container {
		justify-self: center;
		position: relative;

		&.left {
			justify-self: start;
		}

		&.right {
			justify-self: end;
		}

		.content-container {
			position: relative;
			display: grid;
			grid-template-columns: 3fr 4fr;
			width: 372px;
			text-decoration: none;
			color: inherit;

			&.fullwidth {
				width: 100%;
			}

			&.outlined {
				outline: 1px solid $color-neutrals-200-tint;
			}

			&:hover,
			&:focus {
				.body {
					.banner-cta-text {
						.banner-icon {
							position: relative;

							@keyframes bounce {
								0%,
								100% {
									transform: translateX(0);
								}

								50% {
									transform: translateX(5px);
								}
							}

							@keyframes bounce {
								0%,
								100% {
									transform: translateX(0);
								}

								50% {
									transform: translateX(5px);
								}
							}

							&.animated {
								animation-duration: 0.5s;
								animation-fill-mode: both;
								animation-timing-function: linear;
								animation-iteration-count: infinite;
							}

							&.bounce {
								animation-name: bounce;
							}
						}
					}
				}
			}

			&.white {
				background: $color-background-white;
			}

			&.gray {
				background: $color-neutrals-25-tint;
			}

			&.blue {
				background: $color-background-blue-light;
			}

			&.transparent {
				background: none;
			}

			.heading {
				padding: 16px 10px 16px 16px;
				width: 100%;
				height: 100%;
				display: grid;
				align-content: center;

				h3 {
					font-weight: 600;
				}
			}

			.body {
				padding: 16px;
				width: 100%;
				align-self: center;
				display: grid;
				align-content: center;

				.banner-content {
					font-size: 16px;
					line-height: 24px;
				}

				.banner-cta-text {
					.banner-cta-link {
						display: flex;
						align-items: center;
						padding-top: 4px;

						.banner-icon {
							margin-left: 8px;
						}
					}
				}
			}

			.divider {
				border-left: 1px solid $color-neutrals-600-shade;
				height: 65%;
				position: absolute;
				left: 42.85%;
				top: 19%;
			}

			@include breakpoint(mobile) {
				width: 100%;
			}
		}
	}
}
</style>
